import resourceService from './resource_service';

const modelName = 'dispense-step';

const attributes = {
  weight: '',
  volume: '',
};

const relationships = {
  chemical: {
    jsonApi: 'hasOne',
  },
  dispenseLog: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
